export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';
//# sourceMappingURL=constants.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/constants.js
// module id = 634
// module chunks = 0